// src/components/Loader.jsx
import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner" />
      <p className='text-sm text-red font-semibold'>Cargando...</p>
    </div>
  );
};

export default Loader;
